import React, { useEffect, useState } from 'react';
import { Box, Snackbar } from '@mui/material';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import '../../components/Settings/Settings.css';
// import RoleAssignmentTab from '../../components/Settings/RoleAssignmentTab';
import OrgMembersTab from '../../components/Settings/OrgMembersTab';
import TeamCard from '../../components/Settings/TeamCard';

const Settings = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  // Redirect to /settings/profile if the base /settings route is accessed
  useEffect(() => {
    if (location.pathname === '/settings') {
      navigate('/settings/org-members', { replace: true });
      console.log('Redirecting to /settings/org-members'); // Debug log
    }
  }, [location.pathname, navigate]);

  console.log('Settings is rendering'); // Debug log

  return (
    <Box>
      <Routes>
        {/* <Route path="profile" element={<ProfileTab />} />
        <Route path="role-assignment" element={<RoleAssignmentTab />} /> */}
        <Route path="org-members" element={<OrgMembersTab />} />
        <Route path="teams" element={<TeamCard />} />
      </Routes>
      
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={() => {
          setSnackbarOpen(false);
          setSnackbarMessage('');
        }}
        message={snackbarMessage}
        sx={{
          '& .MuiSnackbarContent-root': {
            backgroundColor: snackbarMessage.includes('successful') ? '#4caf50' : '#f44336',
          },
        }}
      />
    </Box>
  );
};

export default Settings;